import { render, staticRenderFns } from "./UsersMireo.vue?vue&type=template&id=31c70d58&scoped=true"
import script from "./UsersMireo.vue?vue&type=script&lang=ts"
export * from "./UsersMireo.vue?vue&type=script&lang=ts"
import style0 from "./UsersMireo.vue?vue&type=style&index=0&id=31c70d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c70d58",
  null
  
)

export default component.exports